import { render, staticRenderFns } from "./ReviewReply.vue?vue&type=template&id=5134ac9a"
import script from "./ReviewReply.vue?vue&type=script&lang=js"
export * from "./ReviewReply.vue?vue&type=script&lang=js"
import style0 from "./ReviewReply.vue?vue&type=style&index=0&id=5134ac9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports